/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-12-04 09:48:00
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-12-06 10:45:11
 * @FilePath: /dbrank_b/src/routes/cms/components/FormElement/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import classNames from 'classnames';

export const Input = withStyles(s)(function (props) {
  const { className, ...innerProps } = props;

  return (
    <input className={classNames(s.input, className)} {...innerProps} />
  )
});

export const Button = withStyles(s)(function (props) {
  const { className, ...innerProps } = props;
  return (
    <button className={classNames(s.button, className)} {...innerProps} />
  )
});



// WEBPACK FOOTER //
// src/routes/cms/components/FormElement/index.js